'use client';

import { useDynamicBreadcrumbs } from '@/hooks/use-dynamic-breadcrumbs';

export function BreadcrumbSetup() {
  useDynamicBreadcrumbs();
  return null;
}
